export default __webpack_public_path__ + "static/media/Silver.52be53dd.svg";